import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

type Context = {
  push: (s: string) => void;
  pushPrefix: (s: string) => void;
  pop: () => void;
  popPrefix: () => void;
};

const context = createContext<Context | null>(null);

export function TitleProvider({ children }: { children: ReactNode }) {
  const [prefixes, setPrefixes] = useState<string[]>(["Skipio"]);
  const [titles, setTitles] = useState<string[]>([]);

  const prefix = prefixes[prefixes.length - 1];

  const push = (title: string) => setTitles((titles) => [...titles, title]);
  const pop = () => setTitles((titles) => titles.slice(0, -1));
  const pushPrefix = (title: string) =>
    setPrefixes((titles) => [...titles, title]);
  const popPrefix = () => setPrefixes((titles) => titles.slice(0, -1));

  useEffect(() => {
    const title = titles[titles.length - 1];
    document.title = `${prefix}${title ? ` • ${title}` : ""}`;
  }, [titles]);

  return (
    <context.Provider value={{ push, pop, pushPrefix, popPrefix }}>
      {children}
    </context.Provider>
  );
}

export default function useTitle(title: string) {
  const { push, pop } = useContext(context)!;

  useEffect(() => {
    push(title);
    return () => pop();
  }, [title]);
}

export function useTitlePrefix(title: string) {
  const { pushPrefix, popPrefix } = useContext(context)!;

  useEffect(() => {
    pushPrefix(title);
    return () => popPrefix();
  }, [title]);
}
